/**
 * @file
 * A JavaScript file containing the animations for entire page
 *
 */

/**
 * Enter Espoo JS.
 */
(function (Drupal, $) {
  Drupal.behaviors.animations = {
    attach: function (context) {
      init();
    }
  };

  function init() {
    setAnimClass();
    checkAnimations();
  }

  function setAnimClass() {
    // let h2 = $(document).find('h2');
    // let h3 = $(document).find('h3');
    // let h4 = $(document).find('h4');
    let blockquote = $(document).find('blockquote');

    // addAnimationClass(h2);
    // addAnimationClass(h3);
    // addAnimationClass(h4);
    addAnimationClass(blockquote);
  }

  function addAnimationClass(item) {
    item.map(function(k, val) {
      $(val).addClass('animation');
    });
  }

  function checkAnimations() {
    let animations = $(document).find('.animation');

    animations.map(function(k, val) {
      if (isElementInViewport(val)) {
        triggerAnimation(val);
      }

      window.addEventListener('scroll', function detectScroll (e) {
        if (isElementInViewport(val)) {
          window.removeEventListener('scroll', detectScroll, false);
          triggerAnimation(val);
        }
      }, false);

      window.addEventListener('resize', function detectResize (e) {
        if (isElementInViewport(val)) {
          window.removeEventListener('scroll', detectResize, false);
          triggerAnimation(val);
        }
      }, false);
    });
  }

  function triggerAnimation(val) {
    $(val).addClass('animation--play');
  }

  function isElementInViewport(el) {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    let width = el.offsetWidth;
    let height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < (window.pageYOffset + window.innerHeight) &&
      left < (window.pageXOffset + window.innerWidth) &&
      (top + height) > window.pageYOffset &&
      (left + width) > window.pageXOffset
    );
  }

})(Drupal, jQuery);
